import type { BreakSheetPaper } from '../shared/desktop-api';

const storageKey = 'capturepoint.breakSheetPaper';

/** Letter where it is the paper in the drawer (the US, Canada, Mexico, the Philippines), A4 everywhere else. */
export function localePaper(locale: string): BreakSheetPaper {
  return /-(US|CA|MX|PH)$/i.test(locale) ? 'letter' : 'a4';
}

/** The paper last printed on in this browser, else the locale's. Storage can be absent or refuse. */
export function rememberedPaper(storage: Storage | undefined, locale: string): BreakSheetPaper {
  try {
    const stored = storage?.getItem(storageKey);
    if (stored === 'letter' || stored === 'a4') return stored;
  } catch {
    // A refused read is the same as nothing remembered.
  }
  return localePaper(locale);
}

export function rememberPaper(storage: Storage | undefined, paper: BreakSheetPaper): void {
  try {
    storage?.setItem(storageKey, paper);
  } catch {
    // Remembering the paper is a convenience; the next print asks again.
  }
}
